"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SINGLE_COMMAND_CLI_SYMBOL = void 0;
exports.SINGLE_COMMAND_CLI_SYMBOL = Symbol('SINGLE_COMMAND_CLI').toString();
